<div class="p-4 space-y-6">
  <!-- Audio Player Section -->
  <div class="flex items-center space-x-4">
    <p-button label="Play Audio" (click)="playAudio()" [disabled]="!audioUrl()" icon="pi pi-play"></p-button>

    <div *ngIf="audioUrl()" class="flex-grow">
      <audio controls [src]="audioUrl()" preload="auto" class="w-full"></audio>
    </div>
  </div>

  <!-- Message Input Section -->
  <div class="flex flex-col space-y-2">
    <label for="messageInput" class="font-medium">Message:</label>
    <input
      id="messageInput"
      type="text"
      pInputText
      placeholder="Type your message"
      [ngModel]="message()"
      (ngModelChange)="message.set($event)"
      class="w-full" />
  </div>

  <!-- Storage Path Section -->
  <div class="flex flex-col space-y-2">
    <label for="pathInput" class="font-medium">Storage Path:</label>
    <input id="pathInput" type="text" pInputText placeholder="e.g., audio/lessons/lesson1" [(ngModel)]="internalPath" class="w-full" />
    @if(!internalPath()){
    <span class="text-red-500 text-sm">Empty path, audio will not save to storage</span>
    }
  </div>

  <!-- Speed and Voice Controls Section -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
    <!-- Speed Category -->
    <div class="flex flex-col space-y-2">
      <label for="speedSelect" class="font-medium">Speed Category:</label>
      <p-select
        inputId="speedSelect"
        [options]="speedOptions"
        [(ngModel)]="selectedSpeed"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Speed"
        class="w-full" />
    </div>

    <!-- Speed Rate Slider -->
    <div class="flex flex-col space-y-2">
      <label for="speedSlider" class="font-medium">Speed Rate:</label>
      <div class="flex items-center space-x-2">
        <p-slider inputId="speedSlider" [(ngModel)]="speedRate" [min]="0" [max]="2" [step]="0.1" class="flex-grow" />
        <span class="font-mono text-sm w-8 text-right">{{ speedRate().toFixed(1) }}</span>
      </div>
    </div>

    <!-- Voice Selection -->
    <div class="flex flex-col space-y-2">
      <label class="font-medium">Selected Voice:</label>
      <div class="flex items-center space-x-2">
        <p-button label="Select Voice" icon="pi pi-user-edit" (click)="isVoicesVisible = !isVoicesVisible" class="p-button-outlined"></p-button>
        <span class="text-sm truncate" [title]="selectedVoice()">{{ selectedVoice() || 'Default' }}</span>
      </div>
    </div>
  </div>

  <!-- Generate Audio Button Section -->
  <div class="flex justify-start items-center space-x-4">
    <p-button
      [label]="isGenerating() ? 'Generating...' : 'Generate Audio'"
      [disabled]="isGenerating() || !message()"
      (click)="generateAudio()"
      icon="pi pi-cog"
      [loading]="isGenerating()"></p-button>
    <div *ngIf="isGenerating()" class="flex items-center space-x-2 text-gray-600">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Generating audio, please wait...</span>
    </div>
  </div>
</div>

<!-- Voice Selector Dialog -->
@if(isVoicesVisible){
<p-dialog [(visible)]="isVoicesVisible" header="Voice Selector" [modal]="true" [closable]="true" [style]="{ width: '80vw', 'max-width': '600px' }">
  <lib-voice-selector (onAction)="selectVoice($event)"></lib-voice-selector>
</p-dialog>
}
